import React from "react";
import GamePageTemplate from "../GamePageTemplate";

export const CasinoPage = () => {
  return (
    <GamePageTemplate
      pageTitle="Live Casino"
      bannerTitle="Live Casino"
      bannerImage="/images/roulette-wide.jpg"
      fetchParams={{ isLiveGame: true }}
      showGameTypeFilter={true}
      excludeGameTypes="sports"
    />
  );
};

export default CasinoPage;
